import {ROOT_URL} from "../../../config/url";
import {useAction, useObject} from "@vokymlak/kabinet-ui";

function useIntegrationAlfabank() {
  const {
    object: [object, setObject],
    update: [isUpdateObject, setIsUpdateObject, changeUpdateObject],
  } = useObject({
    apiUrl: "/api/alfabank",
    rootUrl: ROOT_URL,
  });

  useAction(["alfabank"], () => setIsUpdateObject(!isUpdateObject));

  return {
    object,

    setIsUpdateObject,
    isUpdateObject,
  };
}

export default useIntegrationAlfabank;
